import React, { useState, useEffect } from 'react';
import '../styles/NotesTable.css';

const PerformanceTable = ({ studentId, openPerformancesDialogExternally, setOpenPerformancesDialogExternally }) => {
  const [performances, setPerformances] = useState(() => {
    const savedPerformance = localStorage.getItem('tempPerformances');
    return savedPerformance ? JSON.parse(savedPerformance) : [];
  });

  useEffect(() => {
    if (openPerformancesDialogExternally) {
      setShowDialog(true);
      setOpenPerformancesDialogExternally(false); // Reset parent signal
    }
  }, [openPerformancesDialogExternally, setOpenPerformancesDialogExternally]);

  const [performance, setPerformance] = useState({
    note: '',
    rating: '',
    studentId: studentId || null,
  });

  const [showDialog, setShowDialog] = useState(false);
  const [showPopup, setShowPopup] = useState(false);

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setPerformance({ ...performance, [e.target.name]: e.target.value });
    setErrors((prev) => ({ ...prev, [e.target.name]: '' }));
  };

  const validatePerformance = () => {
    let tempErrors = {};
    if (!performance.note.trim()) tempErrors.note = "Note is required";
    if (!performance.rating.trim()) tempErrors.rating = "Rating is required";
    return tempErrors;
  };

  const handleAddNote = () => {
    const validationErrors = validatePerformance();

    if (!performance.note.trim() && !performance.rating.trim()) {
      setShowPopup(true);
      return;
    }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const updated = [...performances, performance];
    setPerformances(updated);
    localStorage.setItem('tempPerformances', JSON.stringify(updated)); // ✅ consistent key

    setPerformance({
      note: '',
      rating: '',
      studentId: studentId,
    });
    setErrors({});
    setShowDialog(false);
  };

  useEffect(() => {
    setPerformance((prev) => ({
      ...prev,
      studentId: studentId || prev.studentId,
    }));
  }, [studentId]);

  return (
    <div className="note-container">
      {performances.length > 0 && (< div className="note-header">
        <h3>Student Performance</h3>
      </div>
      )}

      {
        showDialog && (
          <div className="dialog-backdrop">
            <div className="dialog-box">
              <h4>Add Student Performance</h4>

              <div className="form-group">
                <label htmlFor="note">Note</label>
                <input
                  type="text"
                  id="note"
                  name="note"
                  placeholder="Enter student note"
                  value={performance.note}
                  onChange={handleChange}
                />
                {errors.note && <div className="error-text">{errors.note}</div>}
              </div>

              <div className="form-group">
                <label htmlFor="rating">Rating</label>
                <input
                  type="text"
                  id="rating"
                  name="rating"
                  placeholder="Enter student rating"
                  value={performance.rating}
                  onChange={handleChange}
                />
                {errors.rating && <div className="error-text">{errors.rating}</div>}
              </div>

              <div className="dialog-actions">
                <button type='button' onClick={handleAddNote}>Save Performance</button>
                <button type='button' className="close-btn" onClick={() => setShowDialog(false)}>Cancel</button>
              </div>
            </div>
          </div>
        )
      }

      {
        showPopup && (
          <div className="popup-backdrop">
            <div className="popup-box">
              <p>Please fill at least one field before adding a performance.</p>
              <button onClick={() => setShowPopup(false)}>OK</button>
            </div>
          </div>
        )
      }

      {
        performances.length > 0 && (<table className="note-table">
          <thead>
            <tr>
              <th>Note</th>
              <th>Rating</th>
            </tr>
          </thead>
          <tbody>
            {performances.map((item, index) => (
              <tr key={index}>
                <td>{item.note}</td>
                <td>{item.rating}</td>
              </tr>
            ))}
          </tbody>
        </table>
        )
      }
    </div >
  );
};

export default PerformanceTable;
